import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
} from 'recompose';
import AnimateHeight from 'react-animate-height';
import * as r from 'ramda';

export const PureSettings = ({
  children,
  height,
}) => (
  <AnimateHeight
    duration={300}
    height={height}
    animateOpacity={true}
    easing="ease-in-out"
  >
    {children}
  </AnimateHeight>
);

export const enhance = compose(
  setDisplayName('Settings'),
  withProps((ownerProps) => ({
    height: r.ifElse(
      r.propEq('expanded', true),
      r.always('auto'),
      r.always(0),
    )(ownerProps),
  })),
);

export default enhance(PureSettings);
